{
  "eyebrow": "WHY CARII",
  "title": "We are the agent of trust between students.",
  "cards": [
    {
      "mark": "1",
      "title": "Verified students",
      "body": "Every host and renter is a verified campus member."
    },
    {
      "mark": "2",
      "title": "Protected payments",
      "body": "Pay in-app; hosts get paid after a clean return."
    },
    {
      "mark": "3",
      "title": "Campus-first",
      "body": "Everything happens where you already are — no trips off campus."
    },
    {
      "mark": "4",
      "title": "Student pricing",
      "body": "Rates built for student budgets, from a few ringgit an hour."
    }
  ]
}
